interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/fe226e3a566555ddeb1e5a20b9b4643c/5ff4ff3d5009244f40339f86dca03486.jpeg" 
              alt="FluxPoint Digital LLC" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#1A2B4A]' : 'text-white hover:text-gray-200'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('capabilities')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#1A2B4A]' : 'text-white hover:text-gray-200'
              }`}
            >
              Capabilities
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#1A2B4A]' : 'text-white hover:text-gray-200'
              }`}
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#1A2B4A]' : 'text-white hover:text-gray-200'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className={`hidden md:block px-6 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'border-2 border-[#1A2B4A] text-[#1A2B4A] hover:bg-[#1A2B4A] hover:text-white'
                : 'border-2 border-white text-white hover:bg-white hover:text-[#1A2B4A]'
            }`}
          >
            Get in Touch
          </button>
        </div>
      </div>
    </nav>
  );
}